import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GridOperator from './grid-operator';
import GridOperatorDetail from './grid-operator-detail';
import GridOperatorUpdate from './grid-operator-update';
import GridOperatorDeleteDialog from './grid-operator-delete-dialog';

const GridOperatorRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GridOperator />} />
    <Route path="new" element={<GridOperatorUpdate />} />
    <Route path=":id">
      <Route index element={<GridOperatorDetail />} />
      <Route path="edit" element={<GridOperatorUpdate />} />
      <Route path="delete" element={<GridOperatorDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GridOperatorRoutes;
